import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user.js';
import editor from './modules/editor.js';
import ai from './modules/ai.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  getters: {
    theme: state => state.user.theme,
    miniEnv: state => state.user.miniEnv,
    appId: state => state.user.appId,
    exhibitionId: state => state.user.exhibitionId,
    languageType: state => state.user.languageType,
    subjectType: state => state.user.subjectType,
    terminal: state => state.user.terminal,
    preReg: state => state.user.yudengji === 'true',
    id: state => state.user.id,
    bot_id: state => state.ai.bot_id,
    user_id: state => state.ai.user_id,
    ai_token: state => state.ai.ai_token
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    editor,
    ai
  },
  plugins: [  
    createPersistedState({  
      storage: window.sessionStorage, // 或者使用 localhostStorage  
    })
  ]
});
